module.exports = __webpack_public_path__ + "media/S1E1_RetailVideo.c48151a4.mp4";